import {
  AsyncTypeaheadMenuProps,
  MenuComponents,
} from "@skv/core/src/components";

interface MenuProps extends RenderMenuProps<string> {
  isLoading: boolean;
  search: string;
}

interface RenderMenuProps<T> {
  results: T[];
  menuProps: AsyncTypeaheadMenuProps;
  menuComponents: MenuComponents<T>;
}

export const LocationMenu = (props: MenuProps) => {
  const { isLoading, search, menuProps, results } = props;
  const { Menu, MenuItem, MenuHeader } = props.menuComponents;

  if (isLoading) {
    return (
      <Menu
        {...menuProps}
        ref={menuProps.ref as React.MutableRefObject<HTMLUListElement>}
        aria-labelledby="where-heading"
      >
        <MenuHeader id="where-heading">Loading please wait...</MenuHeader>
      </Menu>
    );
  }

  // Render initial suggestions if where input is < 2 chars
  // for now, we know initialSuggestions[0] is online or remote,
  if (search.length <= 2) {
    return (
      <Menu
        {...menuProps}
        ref={menuProps.ref as React.MutableRefObject<HTMLUListElement>}
        aria-labelledby="where-heading"
      >
        <MenuHeader id="remote-heading">Remote</MenuHeader>
        <MenuItem option={results[0]} position={0} />
        <MenuHeader id="where-heading">Suggested areas</MenuHeader>
        {results.slice(1).map((result, idx) => (
          <MenuItem key={result} option={result} position={idx + 1} />
        ))}
      </Menu>
    );
  }

  return (
    <Menu
      {...menuProps}
      ref={menuProps.ref as React.MutableRefObject<HTMLUListElement>}
      aria-labelledby="where-heading"
    >
      {results.length ? (
        results.map((result, idx) => (
          <MenuItem key={idx} option={result} position={idx} />
        ))
      ) : (
        <MenuHeader id="where-heading">No results</MenuHeader>
      )}
    </Menu>
  );
};
